import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'

const Navbar = () => {
  const {currentUser} = useAuth()
  
  return (
    <div className='app-navbar flex-shrink-0'>
      
      <div className={clsx('app-navbar-item', itemClass)}>
        <div className='d-flex align-items-center'>
          {/* User info */}
          <div className='d-none d-md-flex flex-column align-items-end me-3'>
            <div className='fw-bolder fs-6 text-gray-800'>
              {currentUser?.name || 'Usuário'}
            </div>
            <div className='fw-normal fs-7 text-muted'>
              {currentUser?.email || ''}
            </div>
          </div>
          
          {/* User avatar with menu trigger */}
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            <img
              src={toAbsoluteUrl('/media/avatars/user.png')}
              alt=''
              style={{maxWidth: '35px', maxHeight: '35px'}}
            />
          </div>
          <HeaderUserMenu />
        </div>
      </div>
      {/* 
      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Navbar}
